import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import { useChatContext } from "../../../context/ChatContext";

const MessageIcon = ({ row }) => {
  const { openChat } = useChatContext();
  const unread = Number(row?.unreadCount ?? row?.unread_count ?? 0);
  // Order created — the conversation is read-only, so mute the icon and the badge.
  const isLocked = Number(row?.status) === 8;

  return (
    <div
      className="relative inline-flex"
      title={isLocked ? "Order created — chat is closed (view only)" : "Click to open chat"}
    >
      <SlIcon
        library="lucide"
        name="message-circle"
        className="text-lg cursor-pointer"
        onClick={(e) => { e.stopPropagation(); openChat(row); }}
      />
      {unread > 0 && (
        <span
          className={`absolute -top-2 -right-2 z-10 min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] rounded-full shadow ${
            isLocked
              ? "font-semibold text-gray-700 bg-gray-200 border border-gray-300"
              : "font-semibold text-white bg-green-500"
          }`}
        >
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </div>
  );
};

export default MessageIcon;
